module.exports = __webpack_public_path__ + "static/media/stofferingen-51.73f2b5dd.jpg";